import React from "react";
import { useMsal } from "@azure/msal-react";
import { clearUserInfo } from "../../UserAuthAndAdminSlice_Store";
import { resetDirectLine } from "../../directLlineClient";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";

/**
 * Component props interface
 */
interface LogoutButtonProps {
  className?: string;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ className = "" }) => {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();
  const userAuthInfo = useAppSelector(state => state.userAuthAndAdminSlice);

  const handleLogout = () => {
    resetDirectLine();

    // Check if this is a demo/username login or MSAL login
    const isDemo = userAuthInfo.accessToken === null || userAuthInfo.userId?.startsWith('auth-');

    if (isDemo) {
      // For demo/username logins, just clear Redux state
      dispatch(clearUserInfo());
      // Force a page reload to ensure proper logout state
      window.location.reload();
    } else {
      // For MSAL logins, clear Redux and redirect through MSAL
      dispatch(clearUserInfo());
      instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin,
      });
    }
  };

  return (
    <button
      onClick={handleLogout}
      className={`inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition duration-150 ease-in-out ${className}`}
    >
      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
      </svg>
      Sign Out
    </button>
  );
};

export default LogoutButton;